import { type Project, type Contact, ProjectType } from '@/generated/graphql';
import { Constants } from '@/constants';
import { PROJECT_TABS } from '@/features/Project';

export const getProjectIconName = (project?: Project) => {
	if (project?.isPrivate) {
		return 'icon-briefcase-lock-filled-16';
	}

	if (project?.projectType === ProjectType.Retainer) {
		return 'icon-briefcase-arrow-filled-16';
	}

	if (project?.projectType === ProjectType.Internal) {
		return 'icon-briefcase-house-filled-16';
	}

	return 'icon-briefcase-filled-16';
};

export const getProjectBookingTabUrl = (projectId: Project['id']) =>
	`/${Constants.Module.PROJECTS.name}/${Constants.Action.VIEW}/${projectId}${PROJECT_TABS.ResourcePlanning.link}`;

export const getProjectClientUrl = (clientId: Contact['id']) =>
	`/${Constants.Module.COMPANIES.name}/${Constants.Action.VIEW}/${clientId}`;
